import config from 'constants/config'

export const SSR_ACCESS_TOKEN_COOKIE = 'ssr_access_token'

const FAR_FUTURE_EXPIRY = 'Wed, 11 Jul 2040 00:00:00 GMT'
const PAST_EXPIRY = 'Thu, 01 Jan 1970 00:00:00 GMT'

// Agent hub only, so every other brand's cookie stays byte-identical: setting
// SameSite explicitly opts out of Chrome's Lax+POST grace, which applies only to
// cookies that leave it unspecified. Lax rather than Strict, because the OIDC
// callback is a cross-site top-level navigation back from svc-auth that Strict
// would withhold the cookie on. No Secure — local dev serves over plain http,
// where the browser would drop it; adding it needs a scheme check.
const HOST_ONLY_FLAGS = '; SameSite=Lax'

// A cookie carrying an explicit Domain= is sent to every subdomain (RFC 6265).
// Agent Hub sits on leagenthub.com with the agent portal on portal.leagenthub.com,
// so a domain-scoped token here reaches the portal, which then fails to log in
// with it. Host-only keeps it on this app. Other brands are left as they were.
const isHostOnly = (): boolean => config.agentHub.isEnabled

// A wide copy from before this change runs to 2040 and, sharing the path but
// being older, is sent first — and parsers keep the first — so it would shadow
// the host-only one and go on reaching the portal. Deleting it repeats its Domain.
function expireDomainScoped(): void {
  if (!document.domain) {
    return
  }

  document.cookie = `${SSR_ACCESS_TOKEN_COOKIE}=; expires=${PAST_EXPIRY}; path=/; domain=${document.domain}`
}

export function writeSsrAuthTokenCookie(accessToken: string): void {
  if (!accessToken) {
    clearSsrAuthTokenCookie()
    return
  }

  if (isHostOnly()) {
    // Clear before writing, never after. Browsers disagree about whether
    // `domain=` on a single-label host (localhost) addresses the same cookie as
    // a host-only write, and clearing afterwards deletes the token wherever it
    // does. This order is correct under both readings.
    expireDomainScoped()
    document.cookie = `${SSR_ACCESS_TOKEN_COOKIE}=${accessToken}; expires=${FAR_FUTURE_EXPIRY}; path=/${HOST_ONLY_FLAGS}`
    return
  }

  document.cookie = `${SSR_ACCESS_TOKEN_COOKIE}=${accessToken}; expires=${FAR_FUTURE_EXPIRY}; path=/; domain=${document.domain}`
}

export function clearSsrAuthTokenCookie(): void {
  document.cookie = `${SSR_ACCESS_TOKEN_COOKIE}=; expires=${PAST_EXPIRY}; path=/`
  expireDomainScoped()
}
